import Backdrop from "@material-ui/core/Backdrop";
import React, {
  createContext,
  FC,
  useCallback,
  useContext,
  useState,
} from "react";
import { ToastContainer, toast as toastify } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import load from "../../../assets/lottie/load.gif";
import {
  FullscreenToast,
  IFullScreenToastConfig,
} from "../../../components/sucessModal/FullscreenToast";

import "./UIContext.css";
import { Icon } from "@material-ui/core";

interface IUIcontext {
  toast: (
    message: string,
    type: "error" | "success" | "warning",
    onClose?: () => void
  ) => void;
  showLoading: () => void;
  hideLoading: () => void;
  toastFullscreen: (
    message: string | JSX.Element,
    type: "error" | "success" | "warning",
    config?: IFullScreenToastConfig
  ) => void;
  transitionPageAnimation: (CB: () => void) => void;
}

const UIContext = createContext<IUIcontext>({} as IUIcontext);

export const UIProvider: FC = ({ children }) => {
  const [loading, setloading] = useState(false);
  const [fullscrenToast, setfullscrenToast] =
    useState<IFullScreenToastConfig | null>(null);
  const [transitionPage, settransitionPAge] = useState(false);

  const toast = (
    message: string,
    type: "error" | "success" | "warning",
    onClose?: () => void,
  ) => {
    toastify(
      type === "error" ? (
        <div>
          <span className="toastTitle">
            <Icon>cancel</Icon>
            {message}
          </span>
        </div>
      ) : (
        message
      ),
      {
        type: type,
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onClose,
        closeButton: false,
        className: "addedProductToast",
      }
    );
  };

  const toastFullscreen = useCallback(
    (
      message: string | JSX.Element,
      type: "error" | "success" | "warning",
      config?: IFullScreenToastConfig
    ) => {
      setfullscrenToast({
        message,
        type: type,
        time: config?.time ?? 3000,
        color: config?.color,
        buttonText: config?.buttonText,
        onClickButton: config?.onClickButton,
        icon: config?.icon,
        iconSize: config?.iconSize,
        background: config?.background,
        onClose: () => {
          setfullscrenToast(null);
          if (config?.onClose) config?.onClose();
        },
      });
    },
    []
  );

  const showLoading = useCallback(() => {
    setloading(true);
  }, []);
  const hideLoading = useCallback(() => {
    setloading(false);
  }, []);

  const transitionPageAnimation = useCallback((CB: () => void) => {
    settransitionPAge(true);
    setTimeout(() => {
      CB();
    }, 0);
    setTimeout(() => {
      settransitionPAge(false);
    }, 2000);
  }, []);

  return (
    <UIContext.Provider
      value={{
        toast,
        showLoading,
        hideLoading,
        toastFullscreen,
        transitionPageAnimation,
      }}
    >
      {children}
      <FullscreenToast config={fullscrenToast} />
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Backdrop style={{ zIndex: 2500 }} open={loading}>
        <div style={{ margin: "auto", zIndex: 1500 }}>
          <img src={load} alt="" width={150} height={150} />
        </div>
      </Backdrop>

      {transitionPage && (
        <div className="transition-page">
          <div className="transition-logo"></div>
        </div>
      )}
    </UIContext.Provider>
  );
};

export const useUi = () => {
  const context = useContext(UIContext);
  return context;
};
